import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PlusIcon } from '../../../assets/icons/plus.svg';
import MyButton from '../../../shared-components/button/Button';

interface RfidTableActionsProperties {
  onOpenAddCard: () => void;
  onOpenAddGroup: () => void;
}

/**
 * Common action buttons (Add Card & Add Card Group) for RFID management tables
 * @param {RfidTableActionsProperties} properties - Component properties
 * @returns {React.JSX.Element} Common table action buttons
 */
function RfidTableActions(properties: RfidTableActionsProperties): React.JSX.Element {
  const { onOpenAddCard, onOpenAddGroup } = properties;
  const { t, i18n } = useTranslation(['devices', 'sharedComponent']);

  return (
    <div className="rfid-table-header-actions" dir={i18n.dir()}>
      <MyButton
        label={t('addCard')}
        buttonType="submit"
        svgIcon={<PlusIcon />}
        onClickFunc={onOpenAddCard}
      />
      <MyButton
        label={t('addCardGroup')}
        buttonType="primary"
        svgIcon={<PlusIcon />}
        onClickFunc={onOpenAddGroup}
      />
    </div>
  );
}

export default RfidTableActions;
